export default "__VITE_ASSET__1EvRmAC___"